import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

const { carbon } = colorsPalettes;

export const Label = styled.label`
    ${setFontVariant("body2", carbon[300])};
`;
